import React from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker as DatePickerMUI } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@material-ui/core';

const DatePicker = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePickerMUI
        {...props}
        renderInput={(propsInput) => (
          <TextField {...propsInput} error={Boolean(props.error)} helperText={props.error} />
        )}
      />
    </LocalizationProvider>
  )
}
export default DatePicker;
